import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { useAdminImpersonation } from '@/contexts/AdminImpersonationContext';
import { useAuth } from '@/contexts/AuthContext';

interface ViewAsButtonProps {
  profileId: string;
  userName?: string;
  variant?: 'default' | 'ghost' | 'outline' | 'secondary';
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

const ViewAsButton: React.FC<ViewAsButtonProps> = ({ 
  profileId, 
  userName,
  variant = 'outline',
  size = 'sm',
  className = ''
}) => {
  const { profile } = useAuth();
  const { startImpersonation, isImpersonating } = useAdminImpersonation();

  // Only show to admins
  if (!profile || profile.role !== 'admin') {
    return null;
  }

  // Don't show if already impersonating
  if (isImpersonating) {
    return null;
  }

  // Don't show button for current user's profile
  if (profile.id === profileId) {
    return null;
  }

  const handleViewAs = () => {
    console.log('🔍 ViewAsButton - Starting impersonation for profile ID:', profileId);
    startImpersonation(profileId);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleViewAs}
      className={`${className}`}
      title={`View as ${userName || 'this user'}`}
    >
      <Eye className="h-4 w-4 mr-1" />
      View As
    </Button>
  );
};

export default ViewAsButton;